import { SxProps, Theme } from '@mui/material';

export const TypographyStyle: SxProps<Theme> = (theme) => ({
    flex: 1,
    whiteSpace: 'nowrap',
    fontSize: '14px',
    color: theme.palette.primary.main,
    fontWeight: '700',
    textAlign: 'center',
});
